import React from 'react';
import PropTypes from 'prop-types';

const styles = {
	links: { color: '#284263' },
}

const AdDetailsButton = ({ source, disp, record = {} }) => (record[source] && !record['calc_row']) ? <a style={styles.links} href={`/#/member/ad_detail/${record[source]}`}>{disp}</a> : '';

AdDetailsButton.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default AdDetailsButton;


// WEBPACK FOOTER //
// ./src/ads/buttons/OpenAdDetailsButton.js